export default {
  route: {
    home: 'Home',
    dashboard: 'Dashboard',
    users: 'Users',
    clubs: 'Clubs',
    teams: 'Teams',
    categories: 'Categories',
    players: 'Players',
    managers: 'Managers',
    positions: 'Positions',
    activity: 'Activity',
    coaches: 'Coaches',
    documents: 'Documents'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
  },

  auth: {
    login: {
      email: 'Email',
      password: 'Password',
      logIn: 'Log in',
      forgotPassword: 'Forgot password?'
    },

    passwordReset: {
      email: 'Email',
      sendPasswordReset: 'Send password reset email',
      cancel: 'Cancel'
    },

    emailUnverified: {
      pleaseConfirmYourEmailAt: 'Please confirm your email at',
      toContinue: ' to confinue.',
      resendEmailConfirmation: 'Resend email confirmation',
      signInWithAnotherAccount: 'Sign in with another account'
    },

    registerManager: {
      email: 'Email',
      password: 'Password',
      name: 'Name',
      lastName: 'Last name',
      phone: 'Phone number',
      createAccount: 'Create account',
      accept: 'Accept',
      termnsConditions: 'Terms and conditions',
      privacyPolicy: 'Privacy policy',
      cancel: 'Cancel'
    },
  },

  entities: {
    user: { singular: 'User', plural: 'Users' },
    club: {
      singular: 'Club', plural: 'Clubs',
      prop: {
        name: 'Name',
        emailManager: 'Email manager',
        statusManager: 'Status manager',
        logo: 'Logo'
      }
    },
    team: {
      singular: 'Team', plural: 'Teams', numberOfTeams: "Number of teams",
      exportTeamAsPdf: 'Export team pdf',
      prop: {
        name: 'Name',
        category: 'Category',
        locality: 'Locality',
        country: 'Country',
        web: 'Web'
      }
    },
    category: { singular: 'Category', plural: 'Categories' },
    player: {
      singular: 'Player', plural: 'Players',
      numberOfPlayers: "Number of players",
      importPlayers: 'Import players',
      exportPlayers: 'Export players',
      prop: {
        namePublic: 'Sporting name',
        name: 'Name',
        lastName: 'Last name',
        dni: 'Dni/Nie/Passport',
        email: 'Email',
        dorsal: 'Number',
        phone: 'Phone',
        position: 'Position',
        picture: 'Photo',
        birthdate: 'Birth date'
      }
    },
    coach: {
      singular: 'Coach', plural: 'Coaches',
      numberOfCoaches: "Nº coaches",
      importPlayers: 'Import coaches',
      exportCoachesAsPdf: 'Export pdf coaches',
      prop: {
        name: 'Name',
        lastName: 'Last name',
        dni: 'Dni/Nie/Passport',
        email: 'Email',
        birthdate: 'Birth date',
        phone: 'Phone',
        picture: 'Photo'
      }
    },
    teamManager: {
      singular: 'Team manager', plural: 'Team managers',
      numberOfTeamManager: "Nº manager's team",
      exportTeamManagerAsPdf: 'Export pdf team managers',
      prop: {
        name: 'Name',
        lastName: 'Last name',
        dni: 'Dni/Nie/Passport',
        email: 'Email',
        birthdate: 'Birth date',
        phone: 'Phone',
        picture: 'Photo'
      }
    },
    manager: {
      singular: 'Manager', plural: 'Managers',
      prop: {
        name: 'Name',
        lastName: 'Lastname',
        email: 'Email',
        phone: 'Phone'
      }
    },

    fieldManager: {
      singular: 'Field manager', plural: 'Field managers',
      prop: {
        name: 'Name',
        lastName: 'Lastname',
        email: 'Email',
        phone: 'Phone'
      }
    },

    referee: {
      singular: 'Referee', plural: 'Referees',
      prop: {
        name: 'Name',
        lastName: 'Lastname',
        email: 'Email',
        phone: 'Phone'
      }
    },
    position: { singular: 'Position', plural: 'Positions' },
    document: { singular: 'Document', plural: 'Documents', prop: { name: 'Name', document: 'Document' } },
    tournament: {
      singular: 'Tournament', plural: 'Tournaments',
      settingGroups: { title: 'Setting groups', description: 'Drag the team name to the corresponding group' },
      group: 'Group',
      prop: {
        name: 'Name',
        category: 'Category',
        locality: 'Locality',
        country: 'Country',
        web: 'Web'
      }
    }
  },

  notification: {
    savedSuccessfully: 'saved successfully!',
    deletedSuccessfully: 'deleted successfully!',
    invitationHasSendSuccessfully: 'Invitation sent successfully!'
  },

  confirm: {
    areYouSureCloseDialog: 'Are you sure to close this dialog?'
  },

  table: {
    search: 'Search',
    add: 'New',
    addProperty: 'Add property',
    setting: 'Setting',
    details: 'Details',
    edit: 'Edit',
    delete: 'Delete',
    sendInvitation: 'Send invitation',
    cancel: 'Cancel',
    export: 'Export',
    exportAsPdf: 'Export as Pdf',
    import: 'Import',
    history: 'History',
    actions: 'Actions',
    confirm: 'Confirm',
    areYouSure: 'Are you sure?',
    status: 'Status',
    yes: 'Yes',
    no: 'No'
  },

  status: {
    modifiedAt: 'Modified at',
    created: 'Created at',
  },

  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },

  excel: {
    export: 'Export',
    selectedExport: 'Export selected items',
    placeholder: 'Please enter the file name(default excel-list)'
  },

  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },

  validators: {
    isRequired: 'es obligatorio',
    lenghtMustBeLeast: 'length must be at least',
    lenghtMustBeMax: 'length must be a maximum of',
    valueShouldInteger: 'Value should be an integer',
    valueIsRequired: 'Value is required',
    mustBeEmail: 'must be at email',
    shouldBeNumber: 'should be a number',
    mustBeAtLeast: 'must be at least',
    mustBeAMaxOf: 'must be a maximum of',
    valueSize: 'Value size',
    size: 'size',
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js